import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{ themeMode?: string }>()
  .create(({ theme, themeMode }) => ({
    assetAlertsContainer: {
      width: '100%',
      borderRadius: theme.shape.borderRadius,
      '& agWrapperBorderRadius': 0,
      '& .ag-root-wrapper': {
        borderRadius: 0
      }
    },
    assetAlertsContainerHeader: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '1rem !important',
      fontWeight: 'bold'
    },
    assetAlertsTableWrapper: {
      backgroundColor:
        themeMode === 'dark'
          ? `color-mix(in srgb, black 30%, ${theme.vars.palette.background.elevation0})`
          : `color-mix(in srgb, white 30%, ${theme.vars.palette.background.elevation0})`,
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(2)
    }
  }));

export default useStyles;
